"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupContainerStyle = exports.ClassName = exports.ChildrenClassName = exports.BorderWidth = void 0;
var TypeStyle = require("typestyle");
var Colors_1 = require("../../styles/Colors");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var ButtonHeight = 24;
exports.BorderWidth = 1;
exports.ChildrenClassName = TypeStyle.style({
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'inline-flex',
    flexGrow: 1,
    minHeight: ButtonHeight - exports.BorderWidth * 2,
    overflow: 'hidden',
    padding: '0 7px',
    $nest: {
        '.icon > &': { flexGrow: 0, padding: 0 },
    }
});
exports.ClassName = TypeStyle.style(PreventUserSelect_1.PreventUserSelect, {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: exports.BorderWidth + "px solid transparent",
    borderRadius: 1,
    boxSizing: 'border-box',
    color: Colors_1.TextColors.Primary,
    display: 'flex',
    fontFamily: 'inherit',
    fontSize: 12,
    lineHeight: 'normal',
    outline: 'none',
    padding: 0,
    position: 'relative',
    $nest: {
        '&.outline': Colors_1.InteractiveBorderColors,
        '&.line': Colors_1.InteractiveBorderColors,
        '&&&.line': {
            borderLeftColor: 'transparent', borderRightColor: 'transparent', borderTopColor: 'transparent',
            borderBottomLeftRadius: 0, borderBottomRightRadius: 0,
        },
        '&.text, &.icon': {
            display: 'inline-flex',
        },
        '&.text:enabled, &.icon:enabled': {
            cursor: 'pointer',
        },
        '&:hover:enabled:not(:focus)': { backgroundColor: Colors_1.TextFieldHoverColor },
        '&&&:active:enabled': { backgroundColor: '#ebebeb', borderColor: Colors_1.TextFieldBorderColors.Hover },
        '&&&&:focus': FocusIndicators_1.DefaultFocusIndicator,
        '.valid > &': {
            color: Colors_1.TextColors.Valid,
            $nest: {
                '&.outline, &.line': { borderColor: FocusIndicators_1.ValidFocusIndicator.borderColor },
                '&&&:focus': FocusIndicators_1.ValidFocusIndicator,
            }
        },
        '&[aria-invalid="true"]': {
            color: Colors_1.TextColors.Error,
            $nest: {
                '&.outline, &.line': { borderColor: FocusIndicators_1.ErrorFocusIndicator.borderColor },
                '&&&:focus': FocusIndicators_1.ErrorFocusIndicator,
            }
        },
        '.dark > &': {
            backgroundColor: 'transparent !important',
            color: Colors_1.InvertTextColors.Primary,
        },
        '.dark > &.outline': Colors_1.InvertInteractiveBorderColors,
        '.dark > &.line': Colors_1.InvertInteractiveBorderColors,
        '.dark > &&&:focus': FocusIndicators_1.InvertFocusIndicator,
    }
});
exports.PopupContainerStyle = Object.freeze({
    position: 'absolute',
});
//# sourceMappingURL=DropdownButtonStyles.js.map